module.exports = __webpack_public_path__ + "media/svg-new/image-editor-b469adf1.svg";